<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <div style="display: grid;grid-template-columns: 31% 1fr;grid-gap: 72px;">
      <div
        class="pa-4 d-flex flex-column"
      >
        <div
          class="d-flex"
          @click="backToDashboard"
        >
          <logo-display />
        </div>
        <div class="text-h2 font-weight-black mt-12">
          {{ $t('BusinessSituation') }}，<br>{{ $t('UnderControl') }}
        </div>
        <div class="text-body-2 text--secondary font-weight-regular mt-8">
          {{ $t('AadenCalculatesAutomatically') }}
        </div>
        <v-spacer />
        <restaurant-logo-display
          :store-img="storeLogo"
          :store-name="storeInfo.name"
        />
      </div>
      <div
        class=""
      >
        <v-row class="mt-4">
          <v-col>
            <v-card
              :style="{
                background:'  linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.5) 36%, rgba(255,255,255,0) 100%),' +
                  'url('+require('@/assets/background/1.webp')+') center / cover'
              }"
              class="pa-12 px-12"
              elevation="0"
              style="border-radius: 24px !important;"
            >
              <div class="d-flex align-center">
                <div class="d-flex justify-center flex-grow-1 mr-16">
                  <div class="text-h1 font-weight-black mr-12">
                    {{ monthOfReport }}
                  </div>
                </div>

                <div
                  class="d-flex flex-column"
                  style="width: 220px;height: 280px"
                >
                  <div class="text-caption">
                    {{ $t('MonthsPreview') }}
                  </div>
                  <div class="text-body-1 font-weight-black mt-4">
                    {{ $t('UnderstandYourBusiness') }}
                  </div>
                  <v-spacer />
                  <v-btn
                    color="black white-text"
                    elevation="0"
                    @click="showReportGenerate"
                    style="color: white !important;"
                  >
                    {{ $t('Preview') }}
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card
              class="pa-6"
              elevation="0"
              style="border-radius: 24px !important;background: #fec156;"
              @click="checkReportList"
            >
              <div
                class="d-flex flex-column"
                style="height: 140px"
              >
                <div class="d-flex align-start">
                  <v-chip
                    color="black"
                    outlined
                  >
                    {{ $t('HistoryReport') }}
                  </v-chip>
                  <v-spacer />
                </div>
                <v-spacer />
                <div class="text-caption">
                  {{ $t('Generate') }}
                </div>
                <div class="text-h2 font-weight-black">
                  {{ historyReportList.length }} {{ $t('Pice') }}
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card
              class="pa-6"
              dark
              elevation="0"
              style="border-radius: 24px !important;background: linear-gradient(135deg, rgba(36,83,74,1) 0%, rgba(58,124,102,1) 100%);"
            >
              <div
                class="d-flex flex-column"
                style="height: 140px"
              >
                <div class="d-flex align-start">
                  <v-chip
                    color="white"
                    outlined
                  >
                    {{ $t('EstimatedCosts') }}
                  </v-chip>
                  <v-spacer />
                </div>
                <v-spacer />
                <div class="text-caption">
                  {{ $t('CalculatedBasedOnStock') }}
                </div>
                <div class="text-h2 font-weight-black">
                  {{ lastMonthPurchasingCost | priceDisplay }}
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="false">
          <v-col cols="6">
            <v-card
              class="pa-6"
              dark
              elevation="0"
              style="border-radius: 24px !important;background: #b0a4a8;"
              @click="settingDefaultCost"
            >
              <div
                class="d-flex flex-column"
                style="height: 140px"
              >
                <div>
                  <div class="text-h4 font-weight-medium">
                    {{ $t('ReportDefaults') }}
                  </div>
                  <div class="text-body-2 mt-2">
                    {{ $t('ModifyReportItem') }}
                  </div>
                </div>
                <v-spacer />
                <div class="d-flex">
                  <div
                    v-if="defaultPurchasingList.length === 0 && defaultFixedList.length ===0"
                    class="d-flex align-center justify-center"
                  >
                    <v-icon class="error mr-2">
                      mdi-exclamation-thick
                    </v-icon>
                    <span>{{ $t('NotDetermined') }}</span>
                  </div>
                  <v-spacer />
                  <v-icon size="56">
                    mdi-store-cog
                  </v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card
              class="pa-6"
              elevation="0"
              style="border-radius: 24px !important;background: #eaeee4;"
              @click="showProductPage('https://www.chaichai-gpt.com/')"
            >
              <div
                class="d-flex flex-column"
                style="height: 140px"
              >
                <div class="d-flex align-start">
                  <div class="text-h4 font-weight-medium">
                    {{ $t('AadenGPT') }}
                  </div>
                  <v-spacer />
                  <div class="text-caption text-secondary">
                    {{ $t('TrialVersion') }}
                  </div>
                </div>
                <v-spacer />
                <div class="text-caption">
                  <div> - {{ $t('BusinessProposals') }}</div>
                  <div> - {{ $t(('AnalyzeMarketingCampaigns')) }}</div>
                  <div> - {{ $t('SolveBusinessProblems') }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog
      v-model="showReportGenerateDialog"
      max-width="800"
    >
      <v-card
        class="pa-8"
        color="amber lighten-4"
        style="border-radius: 24px !important;"
      >
        <div>
          <div class="text-h3 font-weight-light">
            {{ monthOfReport }} {{ $t('BusinessReport') }}
          </div>
          <div class="text-h4 mt-8 font-weight-medium">
            🧮 {{ $t('CostAccounting') }}
          </div>
          <loading-provider :loading="loading">
            <div
              class="mt-8"
              style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 24px"
            >
              <template v-if="!inventoryIsActive">
                <v-form
                  ref="formPurchasing"
                  v-model="validPurchasing"
                  style="width: 100%"
                >
                  <v-card
                    :class="showResourceDetail?'pa-2 py-4':'pa-4'"
                    :color="showResourceDetail?'transparent':'amber lighten-4'"
                    elevation="0"
                    height="min-content"
                  >
                    <div>
                      <div class="d-flex align-start">
                        <div>
                          <div class="text-h5">
                            {{ $t('RawMaterialCosts') }}
                          </div>
                          <div
                            v-if="!showResourceDetail"
                            class="text-body-2 text-secondary"
                          >
                            {{ $t('Together') }} {{ realPurchasingCostList.length }} {{ $t('Article') }}
                          </div>
                        </div>

                        <v-spacer />
                        <div class="text-body-1 font-weight-black">
                          {{ totalPurchasingCost | priceDisplay }}
                        </div>
                      </div>
                      <j-space class="mt-4">
                        <template v-if="showResourceDetail">
                          <v-btn
                            color="success lighten-4 black--text"
                            elevation="0"
                            small
                            @click="submitPurchasingList"
                          >
                            <v-icon left>
                              mdi-check
                            </v-icon>
                            {{ $t('confirm') }}
                          </v-btn>
                        </template>
                        <v-btn
                          v-else
                          color="black--text"
                          elevation="0"
                          small
                          @click="showResourceDetail=true"
                        >
                          <v-icon left>
                            mdi-square-edit-outline
                          </v-icon>
                          {{ $t('edit') }}
                        </v-btn>
                      </j-space>
                    </div>
                    <div
                      v-if="showResourceDetail"
                      v-dragscroll
                      class="mt-4"
                      style="max-height: 450px;overflow-y: scroll"
                    >
                      <div
                        v-for="cost in realPurchasingCostList"
                        :key="cost.label"
                      >
                        <div class="text-body-2 mb-1">
                          {{ cost.label }}
                        </div>
                        <v-text-field
                          v-model="cost.value"
                          :placeholder="cost.value| priceDisplay"
                          :rules="rules"
                          color="secondary"
                          dense
                          filled
                          type="number"
                          @focus="cost.value=''"
                        />
                      </div>
                    </div>
                  </v-card>
                </v-form>
              </template>
              <template v-else>
                <v-card
                  :class="showResourceDetail?'pa-2 py-4':'pa-4'"
                  :color="showResourceDetail?'transparent':'white'"
                  elevation="0"
                  height="min-content"
                >
                  <div class="d-flex align-start">
                    <div>
                      <div class="text-h5">
                        {{ $t('RawMaterialCosts') }}
                      </div>
                    </div>
                  </div>
                  <div class="mt-8">
                    <div class="text-h4">
                      {{ $t('DefaultCostsCalcText') }}
                    </div>
                  </div>
                </v-card>
              </template>
              <v-form
                ref="formFixed"
                v-model="validFixed"
                style="width: 100%"
              >
                <v-card
                  :class="showFixedDetail?'pa-2 py-4':'pa-4'"
                  :color="showFixedDetail?'transparent':'amber lighten-4'"
                  elevation="0"
                  height="min-content"
                >
                  <div>
                    <div class="d-flex align-start">
                      <div>
                        <div class="text-h5">
                          {{ $t('FixedCosts') }}
                        </div>
                        <div
                          v-if="!showFixedDetail"
                          class="text-body-2 text-secondary"
                        >
                          {{ $t('Together') }}{{ realFixedCostList.length }} {{ $t('Article') }}
                        </div>
                      </div>
                      <v-spacer />
                      <div class="text-body-1 font-weight-black">
                        {{ totalFixedCost | priceDisplay }}
                      </div>
                    </div>
                    <j-space class="mt-4">
                      <template v-if="showFixedDetail">
                        <v-btn
                          color="success lighten-4 black--text"
                          elevation="0"
                          small
                          @click="submitFixedCostList"
                        >
                          <v-icon left>
                            mdi-check
                          </v-icon>
                          {{ $t('confirm') }}
                        </v-btn>
                      </template>
                      <v-btn
                        v-else
                        color="black--text"
                        elevation="0"
                        small
                        @click="showFixedDetail=true"
                      >
                        <v-icon left>
                          mdi-square-edit-outline
                        </v-icon>
                        {{ $t('edit') }}
                      </v-btn>
                    </j-space>
                  </div>
                  <div
                    v-if="showFixedDetail"
                    v-dragscroll
                    class="mt-4"
                    style="max-height: 450px;overflow-y: scroll"
                  >
                    <div
                      v-for="cost in realFixedCostList"
                      :key="cost.label"
                    >
                      <div class="text-body-2 mb-1">
                        {{ cost.label }}
                      </div>
                      <v-text-field
                        v-model="cost.value"
                        :placeholder="cost.value| priceDisplay"
                        :rules="rules"
                        color="secondary"
                        dense
                        filled
                        type="number"
                        @focus="cost.value=''"
                      />
                    </div>
                  </div>
                </v-card>
              </v-form>
            </div>
          </loading-provider>

          <v-btn
            v-if="showReportInfo"
            class="mt-8"
            color="grey darken-4"
            elevation="0"
            style="border-radius: 8px!important;"
            @click="showReport"
          >
            <v-icon left>
              mdi-firebase
            </v-icon>
            {{ $t('GenerateReport') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <store-report-dialog
      v-model="showReportDialog"
      :date="monthOfReport"
      :fixed-cost-total="totalFixedCost"
      :purchasing-cost-total="totalPurchasingCost"
      :total-cost="totalPurchasingCost + totalFixedCost"
    />
    <v-dialog
      v-model="showDefaultCostSettingDialog"
      max-width="800"
    >
      <default-cost-page
        :dialog-status="showDefaultCostSettingDialog"
        @closeDialog="closeDialog"
      />
    </v-dialog>
    <v-dialog
      v-model="showHistoryReport"
      max-width="400"
    >
      <v-card class="pa-8">
        <div class="d-flex align-center justify-center mb-8">
          <div class="text-h4 font-weight-medium">
            🧮 {{ $t('HistoryReport') }}
          </div>
          <v-spacer />
          <v-icon @click="showHistoryReport = false">
            mdi-close
          </v-icon>
        </div>
        <template v-if="!ReportListLoading">
          <div
            v-for="i in allDateList"
            :key="i.id"
            class="mt-2"
          >
            <div class="d-flex align-center justify-center">
              <div class="text-h4 font-weight-bold">
                {{ i }}
              </div>
              <v-spacer />
              <div
                v-if="historyReportList.includes(i)"
                class="black--text"
                @click="openReport(i)"
              >
                {{ $t('Check') }}
              </div>
              <div
                v-else
                class="blue--text"
                @click="editReport(i)"
              >
                {{ $t('Create') }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="d-flex align-center justify-center my-16">
            <v-progress-circular
              indeterminate
              size="64"
            />
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LogoDisplay from '@/views/widget/uiComponent/LogoDisplay.vue'
import JSpace from '@/views/AadenPages/components/JSpace.vue'
import { dragscroll } from 'vue-dragscroll/src/main'
import StoreReportDialog from '@/views/AadenPages/billAndReport/analysis/report/fragment/StoreReportDialog.vue'
import RestaurantLogoDisplay from '@/views/widget/commonLogic/RestaurantLogoDisplay.vue'
import {
  addFixedCost,
  addPurchasingCost,
  getFirstTimeZBon,
  getFixedCost,
  getFixedDefaultCostList,
  getFixedExtraCostList,
  getPurchasingCost,
  getPurchasingDefaultCostList,
  getPurchasingExtraCostList,
  getReportDate
} from '@/model/dataLayer/api/report/salesReportApi'
import dayjs from 'dayjs'
import { getInfoForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { getCurrentStoreId } from '@/model/dataLayer/api/SaaS/user'
import DefaultCostPage from '@/views/AadenPages/billAndReport/analysis/DefaultCostPage.vue'
import { mapMutations } from 'vuex'
import { getRootUrl } from '@/model/global/GlobalSettings'
import { dateRangeToNow } from '@/model/dataLayer/api/report/report'
import { checkCloudResourceTrack } from '@/model/dataLayer/api/storage/storage'
import LoadingProvider from '@/views/widget/LoadingProvider'

export default {
  name: 'DishStatisticsPage',
  components: {
    LoadingProvider,
    DefaultCostPage,
    RestaurantLogoDisplay,
    StoreReportDialog,
    JSpace,
    LogoDisplay
  },
  directives: {
    dragscroll
  },
  data: function () {
    return {
      inventoryIsActive: false,
      rules: [
        v => (!!v || v === 0) || this.$t('InputFormEmptyHint')
      ],
      validPurchasing: true,
      validFixed: true,
      lastMonthPurchasingList: [],
      currentReport: false,
      ReportListLoading: false,
      allDateList: [],
      historyReportList: [],
      showHistoryReport: false,
      realPurchasingCostList: [],
      realFixedCostList: [],
      loading: false,
      extraFixedList: [],
      extraPurchasingList: [],
      defaultFixedList: [],
      showDefaultCostSettingDialog: false,
      storeInfo: [],
      monthOfReport: dayjs().format('MMM'),
      defaultPurchasingList: [],
      fixedCostList: [],
      tab: 0,
      showReportDialog: false,
      mainPageLoading: false,
      showReportGenerateDialog: false,
      showResourceDetail: true,
      showFixedDetail: true,

      resourceCost: [
        {
          label: this.$t('GroceryShopping'),
          value: 0
        }, {
          label: this.$t('AlcoholicDrinks'),
          value: 0
        }, {
          label: this.$t('NonAlcoholicDrinks'),
          value: 0
        }, {
          label: this.$t('Consumables'),
          value: 0
        }, {
          label: this.$t('DryGoods'),
          value: 0
        }
      ],
      fixedCost: [
        {
          label: this.$t('FixedCostsEmployment'),
          value: 0
        }, {
          label: this.$t('FixedCostsEmploymentFlexible'),
          value: 0
        }, {
          label: this.$t('MonthlyRent'),
          value: 0
        }, {
          label: this.$t('WaterAndElectricityCosts'),
          value: 0
        }, {
          label: this.$t('EquipmentDepreciation'),
          value: 0
        }, {
          label: this.$t('LowValueConsumables'),
          value: 0
        }, {
          label: this.$t('MarketingCosts'),
          value: 0
        }
      ]

    }
  },
  computed: {
    showReportInfo () {
      return this.inventoryIsActive ? !this.showFixedDetail : !this.showFixedDetail && !this.showResourceDetail
    },
    storeLogo () {
      return getRootUrl() + this.storeInfo.buffetLogo
    },
    lastMonthPurchasingCost () {
      return this.lastMonthPurchasingList.reduce((a, b) => a + b, 0)
    },
    totalPurchasingCost () {
      return this.realPurchasingCostList.length > 0
        ? this.realPurchasingCostList.map(it => parseInt(it.value))
          .reduce((a, b) => a + b)
        : 0
    },
    totalFixedCost () {
      return this.realFixedCostList.length > 0
        ? this.realFixedCostList.map(it => parseInt(it.value))
          .reduce((a, b) => a + b)
        : 0
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {
        this.reloadData()
      }
    }
  },
  async mounted () {
    await this.reloadData()
  },

  methods: {
    backToDashboard () {
      this.$router.push({ name: 'dashboard' })
    },
    ...mapMutations(['showProductPage']),
    async checkReportList () {
      this.showHistoryReport = true
    },
    async editReport (item) {
      this.ReportListLoading = true
      this.monthOfReport = dayjs(item).format('YYYY-MM')
      this.ReportListLoading = false
      this.showHistoryReport = false
      this.showReportGenerateDialog = true
      await this.getCostInfo()
    },
    async openReport (item) {
      this.ReportListLoading = true
      this.currentReport = true
      this.realPurchasingCostList = await getPurchasingCost(item)
      this.realFixedCostList = await getFixedCost(item)
      this.monthOfReport = dayjs(item).format('YYYY-MM')
      this.currentReport = false
      this.ReportListLoading = false
      this.showHistoryReport = false
      this.showReportDialog = true
    },
    closeDialog () {
      this.showDefaultCostSettingDialog = false
    },
    settingDefaultCost () {
      this.showDefaultCostSettingDialog = true
    },
    async showReportGenerate () {
      this.showReportGenerateDialog = true
      await this.getCostInfo()
    },
    async getCostInfo () {
      this.loading = true
      this.realPurchasingCostList = this.defaultPurchasingList.length > 0
        ? this.defaultPurchasingList.concat(
          this.extraPurchasingList)
        : this.resourceCost.concat(this.extraPurchasingList)
      this.realFixedCostList = this.defaultFixedList.length > 0
        ? this.defaultFixedList.concat(
          this.extraFixedList)
        : this.fixedCost.concat(this.extraFixedList)
      this.loading = false
    },
    async submitFixedCostList () {
      if (this.$refs.formFixed.validate()) {
        await addFixedCost(this.realFixedCostList, this.monthOfReport)
        this.showFixedDetail = false
      }
    },
    async submitPurchasingList () {
      if (this.$refs.formPurchasing.validate()) {
        await addPurchasingCost(this.realPurchasingCostList, this.monthOfReport)
        this.showResourceDetail = false
      }
    },
    async showReport () {
      this.showReportDialog = true
    },
    async reloadData () {
      this.inventoryIsActive = await checkCloudResourceTrack()
      this.historyReportList = await getReportDate()
      const res = await getFirstTimeZBon()
      this.allDateList = dateRangeToNow([res,
        dayjs().format('YYYY-MM-DD')]
      )
      this.storeInfo = await getInfoForDeviceId(await getCurrentStoreId())
      this.lastMonthPurchasingList = (await getPurchasingCost(dayjs().format('YYYY-MM'))).map(
        it => parseFloat(it.value))
      this.defaultPurchasingList = (await getPurchasingDefaultCostList())
      this.defaultFixedList = (await getFixedDefaultCostList())
      this.extraPurchasingList = (await getPurchasingExtraCostList()) ?? []
      this.extraFixedList = (await getFixedExtraCostList()) ?? []
      this.mainPageLoading = true
      this.mainPageLoading = false
    }
  }
}
</script>
<style>
</style>
